import {JSONModel, jsonProperty} from "../json.model";

export class ContactLocaleModel extends JSONModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") description: string;
}
